import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Dots from '../../../../assets/images/Dots.svg';
import { getPathForSurvey } from '../../../../utils/helper';
import ActiveDots from '../../../../assets/images/active-dots.svg';

const TeamCard = ({ item, handleDelete, Id, setId, button = false, options = true }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleDropdownToggle = (id) => {
    setId(id);
    setIsOpen(!isOpen);
  };

  return (
    <div className="border-[1.5px] border-shoorah-borderGray rounded-2xl p-4 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder">
      <div className="flex items-center justify-between">
        <h4 className="mb-1 font-bold text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg line-clamp-1 w-[calc(100%-40px)]">
          {item?.title}
        </h4>
        {options && (
          <button className="relative" onClick={() => handleDropdownToggle(item?._id)}>
            <img src={Dots} alt="Dots icon" className="w-6 h-6 block dark:hidden" />
            <img src={ActiveDots} alt="Dots icon" className="w-6 h-6 hidden dark:block" />

            {isOpen && Id === item?._id && (
              <div className="absolute -left-20 top-4 z-10 mt-1 w-[106px] bg-white divide-y divide-shoorah-gray1 border-[1.5px] dark:border-shoorah-darkBorder dark:bg-shoorah-darkBgTabColor border-shoorah-gray1 rounded-lg">
                <ul className="py-2 text-[16px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg w-full">
                  <li>
                    <button
                      onClick={() =>
                        navigate(
                          getPathForSurvey(`/team-challanges/add-edit-challenges?id=${item?._id}`)
                        )
                      }
                      className="block px-4 py-1 w-full text-left hover:bg-gray-100 dark:hover:bg-shoorah-darkBgColor"
                    >
                      Edit
                    </button>
                  </li>
                  <li className="w-[calc(100%-32px)] h-[1px] bg-shoorah-gray1 mx-auto my-1"></li>
                  <li>
                    <button
                      onClick={() => handleDelete(item?._id)}
                      className="block px-4 py-1 w-full text-left hover:bg-gray-100 dark:hover:bg-shoorah-darkBgColor"
                    >
                      Delete
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </button>
        )}
      </div>
      <p
        className={`text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg 2xl:w-[75%] xl:w-[80%] lg:w-[75%] line-clamp-2 ${
          button ? 'mb-3' : ''
        }`}
      >
        {item?.description}
      </p>
      {button && (
        <button className="btn-primary btn-sm">
          Purchase
        </button>
      )}
    </div>
  );
};

export default TeamCard;
